import React from "react";
import { Link } from "react-router-dom";

const Contact = () => {
  return (
    <section className="contact py-80">
      <div className="container container-lg">
        <div className="row gy-5">
          <div className="col-lg-12">
            <div
              className="contact-box px-24 py-40 shipping-content"
              style={{ lineHeight: "1.8" }}
            >
              <style>{`
                .shipping-content h1,
                .shipping-content h2,
                .shipping-content h3,
                .shipping-content h4,
                .shipping-content h5,
                .shipping-content h6 {
                  font-size: 28px;
                  margin-top: 20px;
                  margin-bottom: 20px;
                  font-weight: 600;
                }
                .shipping-content p {
                  margin-bottom: 15px;
                }
                .shipping-content a {
                  color: #007bff;
                  text-decoration: none;
                }
                .shipping-content a:hover {
                  text-decoration: underline;
                }
              `}</style>

              <h2>SHIPPING DELIVERY POLICY</h2>
              <p>
                <strong>Last updated November 03, 2025</strong>
              </p>

              <p>
                Please carefully review our Shipping & Delivery Policy when
                purchasing our products. This policy will apply to any order you
                place with us.
              </p>

              <h3>WHAT ARE MY SHIPPING DELIVERY OPTIONS?</h3>
              <p>
                <strong>Free Shipping</strong>
              </p>
              <p>We offer free 5–7 days shipping on all orders.</p>

              <h3>DO YOU DELIVER INTERNATIONALLY?</h3>
              <p>We do not offer international shipping.</p>

              <h3>HOW CAN YOU CONTACT US ABOUT THIS POLICY?</h3>
              <p>
                If you have any further questions or comments, you may contact
                us by:
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:info@printingdealz.com">
                  info@printingdealz.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
